import { render, staticRenderFns } from "./InventoryManager.vue?vue&type=template&id=4495ecca&scoped=true&"
import script from "./InventoryManager.vue?vue&type=script&lang=js&"
export * from "./InventoryManager.vue?vue&type=script&lang=js&"
import style0 from "./InventoryManager.vue?vue&type=style&index=0&id=4495ecca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495ecca",
  null
  
)

export default component.exports